import { Home } from './pages/home/home';
import Login from './pages/login/login';
import { Register } from './pages/register/register';
import { Terms } from './pages/term/terms';
import { Inicio } from './pages/inicio/inicio'
import CoralForm from './pages/addpost/addpost';
import Biblioteca from './pages/biblioteca/biblioteca';
import SuccessPage from './pages/addpost/sucess/sucess';
import Admin from './pages/admin/admin';
import Mod from './pages/mod/mod';
import ProtectedRoute from './protectroute';
import RestrictedAccess from './pages/private/private';

export const routes = [
    { path: '/', element: <Home /> },
    { path: '/register', element: <Register /> },
    { path: '/login', element: <Login /> },
    { path: '/terms', element: <ProtectedRoute><Terms /></ProtectedRoute> },
    { path: '/inicio', element: <ProtectedRoute><Inicio /></ProtectedRoute> }, 
    { path: '/post', element: <ProtectedRoute><CoralForm /></ProtectedRoute> },
    { path: '/biblioteca', element: <Biblioteca /> },
    { path: '/success', element: <ProtectedRoute><SuccessPage /></ProtectedRoute> },

    // Administrador
    { path: '/admin', element: <ProtectedRoute requiredRole="adm"><Admin /></ProtectedRoute> },

    // Moderador
    { path: '/mod', element: <ProtectedRoute requiredRole="mod"><Mod /></ProtectedRoute> },
    { path: '/mod', element: <ProtectedRoute requiredRole="adm"><Mod /></ProtectedRoute> },

    // PRIVATE
    { path: 'private', element: <ProtectedRoute requiredRole={"mod"}><RestrictedAccess /></ProtectedRoute>},
    { path: 'private', element: <ProtectedRoute requiredRole={"adm"}><RestrictedAccess /></ProtectedRoute>}
];